import React from 'react';

const ContactSection = () => {
  return (
    <section id="contact-us">
      <div className="main-container d-flex flex-column bg-light">
        <div className="offset-md-6 col-md-4 offset-md-1 col-12 bg-white rounded-3 ps-4 pt-3 pb-3 my-auto shadow-sm">
          <ul className="list-unstyled d-flex flex-column align-items-start px-2 pt-2 mb-2">
            <li className="mb-2">
              <b className="list-header h5 fw-bolder fs-2">CONTACT US</b>
            </li>
            <li className="mb-2">Connect with us to deliver and scale faster</li>
            <li className="mb-1"><b className="text-dark fw-semibold">Email to Copenhagen Team:</b></li>
            <li className="mb-2">spiritcargocopenhagen@sas.com</li>
            <li className="mb-1"><b className="text-dark fw-semibold">Email to Billund Team:</b></li>
            <li className="mb-1">spiritcargobillund@sas.com</li>
          </ul>
          <button
            className="btn rounded-pill"
            style={{
              color: '#000099',
              fontWeight: 900,
              textTransform: "uppercase",
              backgroundColor: '#FFD6AF',
              border: "none"
            }}
          >
            Email Us
          </button>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;